import React from 'react';
import ConsensusTableWidgetRenderer from './ConsensusTableWidgetRenderer';

const Preview: React.FC = () => (
  <ConsensusTableWidgetRenderer config={{}} />
);

export default Preview;
